// extracted by mini-css-extract-plugin
export default {"container":"SliderBase_container__WFuel","slick-dots":"SliderBase_slick-dots__OELay"};